var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, ModelSync, Prop, Watch } from 'vue-property-decorator';
import { BRow, BCol, BFormRadioGroup, BFormRadio, BOverlay, BFormGroup, BInputGroup, BFormInput, BButton, BCollapse, VBToggle, BAlert } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import uniq from 'lodash/uniq';
import axios from 'axios';
import TabHeading from 'components/picture-frames/Tabs/TabHeading.vue';
import MountboardColours from 'components/MountboardColours.vue';
import MountWidthSelector from 'components/picture-frames/Tabs/MountOptions/MountWidthSelector.vue';
import { getMountPrice } from 'ts/modules/pricing';
import { validateMount } from 'ts/modules/validation';
let MountOptions = class MountOptions extends Vue {
    constructor() {
        super(...arguments);
        this.minBorderWidth = 10;
        this.minReveal = 3;
        this.equalBorderWidth = 50;
        this.loadingMountboards = true;
        this.loading = true;
        this.isSpliced = false;
        this.validation = { isValid: true, problems: [], warnings: [] };
        this.singleMountPrice = "0.00";
        this.doubleMountPrice = "0.00";
        this.isCustomWidths = false;
        this.debouncedUpdate = debounce(this.update, 350);
    }
    onSingleMountClick() {
        if (this.selectedMount.type == 'none') {
            this.selectedMount.type = 'single';
        }
    }
    onDoubleMountClick() {
        if (this.selectedMount.type != 'double') {
            this.selectedMount.type = 'double';
        }
    }
    get isEqualBorderValid() {
        return this.equalBorderWidth >= this.minBorderWidth;
    }
    get isRevealSizeValid() {
        return this.selectedMount.reveal != null && this.selectedMount.reveal >= this.minReveal;
    }
    get mountExternalDimensions() {
        return {
            width: (this.rebateDimensions.width - 9) + (this.selectedMount.type == 'none' ? (this.selectedMount.borders.left + this.selectedMount.borders.right) : 0),
            length: (this.rebateDimensions.length - 9) + (this.selectedMount.type == 'none' ? (this.selectedMount.borders.top + this.selectedMount.borders.bottom) : 0)
        };
    }
    onIsCustomWidthChange(newVal) {
        if (newVal === false) {
            this.onEqualBorderChange();
        }
    }
    onEqualBorderChange() {
        // Update the individual borders
        this.selectedMount.borders.top = this.equalBorderWidth;
        this.selectedMount.borders.left = this.equalBorderWidth;
        this.selectedMount.borders.right = this.equalBorderWidth;
        this.selectedMount.borders.bottom = this.equalBorderWidth;
        this.$emit('input', this.selectedMount);
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            yield Promise.all([
                this.updatePrices(),
                this.validate()
            ]);
            this.loading = false;
        });
    }
    updatePrices() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield Promise
                    .all([
                    // Get single mount price
                    getMountPrice(this.mountExternalDimensions, `MCTS-${((_a = this.selectedMount.top) === null || _a === void 0 ? void 0 : _a.stock_lookup_sku) || '8001'}`, null, true).then(price => this.singleMountPrice = price.price),
                    // Get double mount price
                    getMountPrice(this.mountExternalDimensions, `MCTS-${((_b = this.selectedMount.top) === null || _b === void 0 ? void 0 : _b.stock_lookup_sku) || '8001'}`, `MCTS-${((_c = this.selectedMount.bottom) === null || _c === void 0 ? void 0 : _c.stock_lookup_sku) || '8001'}`, true).then(price => this.doubleMountPrice = price.price)
                ]);
            }
            catch (e) {
                console.log("An error occured when loading mount prices");
            }
        });
    }
    validate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selectedMount.type != 'none' && this.selectedMount.top) {
                let data = yield validateMount(`MCTS-${this.selectedMount.top.stock_lookup_sku}`, this.mountExternalDimensions, this.selectedMount.borders, this.selectedMount.type == 'double' ? `MCTS-${((_a = this.selectedMount.bottom) === null || _a === void 0 ? void 0 : _a.stock_lookup_sku) || '8001'}` : null, this.selectedMount.type == 'double' ? this.selectedMount.reveal : null);
                this.validation = data;
            }
            else {
                this.validation = { isValid: true, problems: [], warnings: [] };
            }
        });
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingMountboards = true;
            let { data } = yield axios.get('/api/materials/mountboard/forSale');
            this.mountboards = data;
            if (uniq(Object.values(this.selectedMount.borders)).length > 1) {
                this.isCustomWidths = true;
            }
            else {
                this.equalBorderWidth = this.selectedMount.borders.top;
            }
            this.loadingMountboards = false;
        });
    }
    mounted() {
        this.update();
    }
};
__decorate([
    ModelSync('mount', 'input', { type: Object })
], MountOptions.prototype, "selectedMount", void 0);
__decorate([
    Prop({ type: Object })
], MountOptions.prototype, "rebateDimensions", void 0);
__decorate([
    Watch('isCustomWidths')
], MountOptions.prototype, "onIsCustomWidthChange", null);
__decorate([
    Watch('equalBorderWidth')
], MountOptions.prototype, "onEqualBorderChange", null);
__decorate([
    Watch('selectedMount', { deep: true }),
    Watch('rebateDimensions', { deep: true })
], MountOptions.prototype, "debouncedUpdate", void 0);
MountOptions = __decorate([
    Component({
        components: {
            BRow, BCol, BFormRadioGroup, BOverlay, BFormGroup, BInputGroup, BFormInput, BButton, BCollapse, BFormRadio, BAlert,
            TabHeading, MountboardColours, MountWidthSelector
        },
        directives: {
            'b-toggle': VBToggle
        }
    })
], MountOptions);
export default MountOptions;
